module.exports = __webpack_public_path__ + "img/b490070.png";